import {Injectable} from '@angular/core';
import {ImageCompressionService} from '../../main/ticket/services/image.compression.service';

@Injectable({
  providedIn: 'root',
})
export class ImageService {

  constructor(private imageCompressionService: ImageCompressionService) {
  }

  public isImage(file: File) {
    const validTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp'];
    return validTypes.indexOf(file.type) !== -1;
  }

  public async decreaseImagesSizes(convertedFiles: File[]) {
    try {
      for (let i = 0; i < convertedFiles.length; i++) {
        if (this.isImage(convertedFiles[i]) && convertedFiles[i].size > 1024 * 1024) {
          convertedFiles[i] = await this.imageCompressionService.compressImage(convertedFiles[i]);
        }
      }
    } catch (error) {
      console.error('Error compressing image:', error);
    }
  }



}